export function booleanToString(booleanValue: boolean | undefined | null, defaultText?: string): string {
    if (booleanValue === undefined || booleanValue === null) {
        return defaultText ?? "";
    }
    return booleanValue ? "Ja" : "Nej"
}